import Header from "PhishingManager/components/Header";
import Step5ReviewStart from "../Step5";
import { CampaignReviewData } from "../Step5/Step5.types";

interface StepProps {
    tenantId: number | string | undefined;
    campaignData: { id: number, name: string, data: CampaignReviewData };
    onBack: () => void;
    onFinish: () => void;
    showPreview: (id: string | number, languageId: number | null) => void;
    setToast: (
        toast: { message: string; type: 'warning' | 'success' }
    ) => void;
    updateName?: (name: string) => void;
}

const ViewSummary: React.FC<StepProps> = ({
    tenantId,
    campaignData,
    onBack,
    onFinish,
    showPreview,
    setToast
}) => {
    return (
        <div className="campaign-step-up view-summary">
            <Header title="View setup summary" description={campaignData.name} onBack={onBack} />
            <div className="step-card-section">
                <Step5ReviewStart {...{ tenantId, campaignId: campaignData.id, onBack, onFinish, showPreview, setToast, showSummary: true, defaultCampaignData: campaignData.data }} />
            </div>
        </div>)
}

export default ViewSummary;